angular.module('bmsApp.settings')
	.factory('RiskAssessmentQuestionTypeSvc', function (CRUDSvc) {

		var prefix = 'api/settings/risk-assessment/question-type/';
		function index(params) {
			return CRUDSvc.get(prefix+'index', params);
		}

		function save(params) {
			return CRUDSvc.post(prefix+'save', params);
		}

		function read(id) {
			return CRUDSvc.get(prefix+'read/' + id);
		}

		function options() {
			return CRUDSvc.get(prefix+'options');
		}

		return {
			index: index,
			save: save,
			read: read,
			options: options,
		};

	});
